import { Component, OnInit } from '@angular/core';
import {Class} from '@models/class';
import {ClassService} from '@services/class/class.service';
import {Input} from '@node_modules/@angular/core';
import {Program} from '@models/program';
import {ProgramCreateComponent} from '@pages/layout/program/program-create/program-create.component';
import {MatDialog, Sort} from '@node_modules/@angular/material';
import {ActionTypes, UpdateProgram} from '@store/program/actions';
import * as ProgramReducer from '@store/program/reducers';
import {Store} from '@node_modules/@ngrx/store';
import {ProgramScheduleComponent} from '@pages/layout/program/program-page/program-schedule/program-schedule.component';
import {Schedule} from '@models/schedule';
import {ConfirmModalComponent} from '@components/confirm-modal/confirm-modal.component';
import * as moment from 'moment';
import {BehaviorSubject} from '@node_modules/rxjs/internal/BehaviorSubject';
import {User} from '@models/user';
import {SetTeachers} from '@store/teacher/actions';
import {TeacherService} from '@services/teacher/teacher.service';
import * as TeacherReducer from '@store/teacher/reducers';

@Component({
  selector: 'app-program-classes',
  templateUrl: './program-classes.component.html',
  styleUrls: ['./program-classes.component.scss']
})
export class ProgramClassesComponent implements OnInit {
  @Input() programSubject: BehaviorSubject<Program>;
  @Input() studentReadOnly = false;
  program: Program;
  classes: Class[] = [];
  refactoredSChedules: any[];
  createDialog;
  confirmDialog;
  currentPageClass;
  teachersByClassids = {};
  multiselectTeachers = [];

  constructor(
    private classService: ClassService,
    private programStore: Store<ProgramReducer.ProgramState>,
    public dialog: MatDialog,
    private teacherService: TeacherService,
    private teacherStore: Store<TeacherReducer.TeacherState>,
  ) {
    // for (let i = 0; i < 15; i++) {
    //   this.classes.push(i);
    // }
  }

  static reorganizeSchedule(program: Program, except = [], daySelected = null, initSchedules = {}, strict = false) {
    let schedule = initSchedules;
      program.classes.map(classc => {
        classc.schedule.map(itemOrigin => {
          let items = [itemOrigin];
          if (daySelected) {
            // console.log(except);
            items = ProgramScheduleComponent.findReplacedSchedule(program, itemOrigin, daySelected);
          }
          if (program.curriculum && program.curriculum.length > 0) {
            const timeStartC = moment(items[0].start, 'HH:mm A').month(items[0].month).date(+items[0].day).year(+items[0].year);
            program.curriculum = program.curriculum.sort((a, b) => {
              return moment(a.start_curriculum, 'YYYY-MM-DD HH:mm:ss').isBefore(moment(b.start_curriculum, 'YYYY-MM-DD HH:mm:ss')) ? -1 : 1;
            });
            // console.log(current_program);
            const curriculumstart = moment(program.curriculum[0].start_curriculum, 'YYYY-MM-DD HH:mm:ss');
            if (timeStartC.isAfter(curriculumstart) || timeStartC.isSame(curriculumstart)) {
              ProgramScheduleComponent.findInitLessonNumber(program, timeStartC);
            }
            // console.log('**** init ****', ProgramScheduleComponent.lessonNumber);
            // console.log('**** init ****', dayTime.diff(curriculumstart));
          }
          items.map(item => {
            // console.log(item);
            if (!item.canceled) {
              if (!schedule[item.month]) schedule[item.month] = {};
              if (!schedule[item.month][item.day]) schedule[item.month][item.day] = [];
              if (strict) {
                let scheduleChecked;
                switch (item.repeat_time) {
                  case 'week':
                    if (item.dayName === daySelected.format('dddd').substring(0, 3).toLowerCase()) {
                      scheduleChecked = Object.assign({}, schedule);
                    }
                    break;
                  case 'none':
                    if (+item.day === +daySelected.date() && +item.month === (daySelected.month() + 1) && +item.year === daySelected.year()) {
                      scheduleChecked = Object.assign({}, schedule);
                    }
                    break;
                }
                if (scheduleChecked) {
                  schedule[item.month][item.day].push({
                    start: item.start,
                    end: item.end,
                    deleted: false,
                    canceled: item.canceled,
                    api: !except.includes(item.id),
                    id: item.id,
                    class_name: item.class_name,
                    class_id: item.class_id,
                    repeat_time: item.repeat_time,
                    dayName: item.dayName,
                    year: item.year,
                    teachers: classc.teachers
                    // lesson: ProgramScheduleComponent.schedulesWithLesson[dayFromCalendar.format('ll')][item.id]
                  });
                }
              } else {
                schedule[item.month][item.day].push({
                  start: item.start,
                  end: item.end,
                  deleted: false,
                  canceled: item.canceled,
                  api: !except.includes(item.id),
                  id: item.id,
                  class_name: item.class_name,
                  class_id: item.class_id,
                  repeat_time: item.repeat_time,
                  dayName: item.dayName,
                  year: item.year,
                  program_name: item.program_name,
                  program_id: item.program_id,
                  teachers: classc.teachers
                });
              }
              schedule[item.month][item.day].sort((a, b) => {
                return b.api !== false;
              });
            }
          });
        });
      });
    // console.log(schedule);
    return schedule;
  }

  ngOnInit() {
    this.programSubject.subscribe(
      resp => {
        this.program = resp;
        if (this.program.classes.some( i => i.teachers && i.teachers.length > 0)) {
          this.resetTeachers();
        }
        this.refactorSchedule();
      }
    );
    if (this.program) {
      this.refactorSchedule();
      if (this.program.preview) {
        this.getAllTeachers();
      }
    }
    // this.teacherService.getAll().subscribe(
    //   (resp : {data: User[]}) => {
    //     // this.teachers = resp.data;
    //     resp.data.map( teach => this.multiselectTeachers.push({
    //       id: teach.id,
    //       itemName: teach.name
    //     }));
    //     this.teacherStore.dispatch(new SetTeachers(resp.data));
    //   }
    // );
  }
  openCreateModal() {
    if (this.studentReadOnly) {
      return;
    }
    ProgramCreateComponent.source = ProgramCreateComponent.source_class;
    ProgramCreateComponent.program = this.program;
    ProgramCreateComponent.editedItem = null;
    ProgramCreateComponent.sourceSchedule = ProgramClassesComponent.reorganizeSchedule(this.program);
    this.createDialog = this.dialog.open(ProgramCreateComponent, { disableClose: true });
    ProgramCreateComponent.dialogRef = this.createDialog;
    this.createDialog.afterClosed().subscribe(result => {
      this.createDialog.close();
      this.getAllTeachers();
    });
    this.createDialog.componentInstance.multiselectTeachers = this.multiselectTeachers;
  }

  openEditModal(schedule) {
    if (this.studentReadOnly) {
      return;
    }
    // console.log(this.teachersByClassids);
    const currentClass = this.getCurrentClass(schedule.class_id);
    ProgramCreateComponent.source = ProgramCreateComponent.source_class_edit;
    ProgramCreateComponent.selectedDate = moment(schedule.date, 'll');
    ProgramCreateComponent.program = this.program;
    ProgramCreateComponent.editedItem = {
      id: schedule.class_id,
      name: schedule.class_name,
      description: currentClass.description,
      schedule: currentClass.schedule,
      selectedSchedule: schedule,
      teachers:  this.teachersByClassids[currentClass.id],
    };
    const daySelected =  moment(schedule.date, 'll');
    ProgramCreateComponent.sourceSchedule = ProgramClassesComponent.reorganizeSchedule(this.program, [schedule.id], daySelected);
    this.createDialog = this.dialog.open(ProgramCreateComponent, { disableClose: true });
    ProgramCreateComponent.dialogRef = this.createDialog;
    this.createDialog.afterClosed().subscribe(result => {
      this.createDialog.close();
    });
    // this.createDialog.componentInstance.multiselectTeachers = this.multiselectTeachers;
  }

  openDeleteModal(schedule) {
    if (this.studentReadOnly) {
      return;
    }
    const currentClass = this.getCurrentClass(schedule.class_id);
    let countSchedules = 0;
    this.refactoredSChedules.map( sch => {
      if (schedule.class_id === sch.class_id) {
        countSchedules++;
      }
    });
    console.log(schedule);
    this.openConfirmPopup(schedule, currentClass, false, countSchedules === 1);

    // if (schedule.repeat_time === 'none') {
    //   this.openConfirmPopup(schedule, currentClass);
    // } else {
    //   this.openConfirmPopup(schedule, currentClass, true);
    // }
  }

  actionDelete(body: {schedule: Schedule, classc: Class, delete_class: boolean}, canceled: boolean) {
    if (this.studentReadOnly) {
      return;
    }
    body.schedule.deleted = true;
    // if (canceled) {
    //   body.schedule.canceled = true;
    // } else {
    //   body.schedule.deleted = true;
    // }
    console.log(body);
    this.onEditClass(body.classc, body.schedule, body.delete_class);
  }

  openConfirmPopup(schedule, classc, repeatEnable = false, delete_class = false) {
    ConfirmModalComponent.insertedObject = this;
    ConfirmModalComponent.repeatable = repeatEnable;
    ConfirmModalComponent.methodDelete = 'actionDelete';
    ConfirmModalComponent.methodDeleteAll = 'actionDelete';
    ConfirmModalComponent.methodDeleteParam = {schedule: schedule, classc: classc, delete_class: delete_class};
    ConfirmModalComponent.methodDeleteAllParam = true;
    ConfirmModalComponent.textModal = 'Delete?';
    ConfirmModalComponent.textButton = 'Delete';
    this.confirmDialog = this.dialog.open(ConfirmModalComponent);
    ConfirmModalComponent.modalRef = this.confirmDialog;
    this.confirmDialog.afterClosed().subscribe(result => {
      this.confirmDialog.close();
    });
  }

  onEditClass(classc: Class, schedule, delete_class: boolean) {
    const date = {};
    date[moment(classc.selectedDay).format('YYYY-MM-DD')] = [schedule];
    this.classService.editClass({
      class_name: classc.name,
      delete_class: delete_class,
      class_description: classc.description,
      schedule: date,
      repeat_time: 'none',
      program_id: this.program.id,
      class_id: classc.id,
      unique_schedule: !schedule.replaced_schedule,
      replaced_schedule: null,
    }).subscribe(
      (resp: {data: {classes: Class[], schedules: Schedule[], replaced_schedules: Schedule[]}}) => {
        this.program.schedule = resp.data.schedules;
        this.program.classes = resp.data.classes;
        this.programStore.dispatch(new UpdateProgram(this.program));
        if (this.confirmDialog) {
          this.confirmDialog.close();
        }
        // console.log(resp);
      }
    );
  }

  refactorSchedule() {
    this.refactoredSChedules = [];
    // this.teachersByClassids = [];

    // console.log(this.program);
    this.program.classes.map( classc => {
      if (classc.schedule.length === 0) {
        let schedule = new Schedule();
        schedule.class_name = classc.name;
        schedule.class_id = classc.id;
        this.refactoredSChedules.push(schedule);
      } else {
        classc.schedule.map(sch => {
          const schDateMoment = moment(sch.year, 'YYYY').month(+sch.month - 1).date(+sch.day);
          sch.date = schDateMoment.format('ll');
          let dayName = 'Sunday';
          // console.log(sch);
          sch.class_name = classc.name;
          sch.class_id = classc.id;
          switch (schDateMoment.isoWeekday()) {
            case 7:
              dayName = 'Sunday';
              break;
            case 1:
              dayName = 'Monday';
              break;
            case 2:
              dayName = 'Tuesday';
              break;
            case 3:
              dayName = 'Wednesday';
              break;
            case 4:
              dayName = 'Thursday';
              break;
            case 5:
              dayName = 'Friday';
              break;
            case 6:
              dayName = 'Saturday';
              break;
          }
          sch.fullDayName = dayName;
          this.refactoredSChedules.push(sch);
        });
      }
      if (classc.teachers) {
        this.setTeacherByIds(classc.id, classc.teachers);
      }
    });
    if (this.studentReadOnly) {
      this.sortData({active: 'weekday', direction: 'asc'});
    }
    // this.getAllTeachers();
  }
  sortData(sort: Sort) {
    const data = this.refactoredSChedules.slice();
    if (!sort.active || sort.direction === '') {
      this.refactoredSChedules = data;
      return;
    }

    this.refactoredSChedules = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      let aDate = moment(a.date, 'll').unix();
      let bDate = moment(b.start, 'hh:mm A').unix();
      if (a.repeat_time === 'week') {
        const sorter = {
          "monday": 1,
          "tuesday": 2,
          "wednesday": 3,
          "thursday": 4,
          "friday": 5,
          "saturday": 6,
          "sunday": 7
        };
        aDate = sorter[a.fullDayName.toLowerCase()];
        bDate = sorter[b.fullDayName.toLowerCase()];
      }
      switch (sort.active) {
        case 'date': return this.compare(aDate, bDate, isAsc);
        case 'weekday': return this.compareWeekday(a, b, isAsc);
        case 'start': return this.compare(moment(a.start, 'hh:mm A').unix(), moment(b.start, 'hh:mm A').unix(), isAsc);
        case 'end': return this.compare(moment(a.end, 'hh:mm A').unix(), moment(b.end, 'hh:mm A').unix(), isAsc);
        case 'class_name': return this.compare(a.class_name, b.class_name, isAsc);
        case 'dayName': return this.compare(moment(a.year, 'YYYY').month(a.month).day(a.dayName).unix(), moment(b.year, 'YYYY').month(b.month).day(b.dayName).unix(), isAsc);
        default: return 0;
      }
    });
  }
  compare(a, b, isAsc) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
  compareWeekday(a, b, isAsc) {
    const dayA = this.getWeekdaySortValue(a);
    const dayB = this.getWeekdaySortValue(b);

    if (dayA !== dayB) {
      return (dayA < dayB ? -1 : 1) * (isAsc ? 1 : -1);
    }

    return moment(a.start || '00:00 AM', 'hh:mm A').unix() < moment(b.start || '00:00 AM', 'hh:mm A').unix() ? -1 : 1;
  }
  getWeekdaySortValue(schedule) {
    const sorter = {
      monday: 1,
      tuesday: 2,
      wednesday: 3,
      thursday: 4,
      friday: 5,
      saturday: 6,
      sunday: 7
    };
    const weekday = schedule && schedule.fullDayName ? schedule.fullDayName.toLowerCase() : '';

    return sorter[weekday] || 8;
  }
  getCurrentClass(class_id) {
    let currentClass;
    this.program.classes.map( classc => {
      if (classc.id === class_id) {
        currentClass = classc;
      }
    });
    console.log(currentClass);
    return currentClass;
  }
  nextPage(event, mode) {
    if (mode === 'class') {
      this.currentPageClass = event;
    }
  }
  setTeacherByIds(class_id: number, teachers: User[]) {
    if (!this.teachersByClassids[class_id]) {
      this.teachersByClassids[class_id] = [];
    }
    teachers.map(item => {
      if (!this.teachersByClassids[class_id].some( t => t.id === item.id)) {
        this.teachersByClassids[class_id].push(item);
        if (!this.multiselectTeachers.some( t => t.id === item.id)) {
          this.multiselectTeachers.push({
            id: item.id,
            itemName: item.name,
          });
        }
      }
    });
  }
  resetTeachers() {
    this.teachersByClassids = {};
    this.multiselectTeachers = [];
  }
  getAllTeachers() {
    let classIds = [];
    this.resetTeachers();
    this.program.classes.map( cl => classIds.push(cl.id));
    if (classIds.length > 0) {
      this.classService.getTeachers(classIds).subscribe(
        (resp: { data: { id: number, class_id: number, name: string }[] }) => {
          resp.data.map(item => {
            this.setTeacherByIds(item.class_id, [item]);
          });
          // this.teacherStore.dispatch(new SetTeachers(resp.data));
        }
      );
    }
  }
}
